import { ClassificationSelector } from '@ui/tags';
import { getClosestTableBody } from '@lib/popups';
import React, { useCallback } from 'react';
import { useApplicationReference, useUpdateDataSecurityApp } from '@hooks';
export const AppClassificationCellEditor = ({ applicationId }) => {
    const { request } = useUpdateDataSecurityApp();
    const { classification } = useApplicationReference(applicationId);
    const handleChange = useCallback((change) => {
        request({
            applicationId,
            classification: change !== null && change !== void 0 ? change : null
        });
    }, [applicationId, request]);
    return (React.createElement(ClassificationSelector, { getPopupContainer: getClosestTableBody, isSpreadsheet: true, onChange: handleChange, value: classification }));
};
